import './amplify-bootstrap';
import { AppComponent } from './app/app.component';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpLoaderFactory } from './app/app.module';
import { LayoutService } from './app/shared/services/layout.service';
import { MainProductServices } from './app/shared/services/main-product.service';
import { NavigationService } from './app/shared/services/navigation.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ProfileService } from './app/shared/services/profile.service';
import { provideRouter, withHashLocation } from '@angular/router';
import { rootRouterConfig } from './app/app.routing';
import { RoutePartsService } from './app/shared/services/route-parts.service';
import { ThemeService } from './app/shared/services/theme.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

if (environment.production) {
	enableProdMode();
	if (window) {
		window.console.log = function () {
		};
	}
}

bootstrapApplication(AppComponent, {
	providers: [
		importProvidersFrom(BrowserModule, TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}), NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })),
		CookieService,
		LayoutService,
		MainProductServices,
		NavigationService,
		ProfileService,
		RoutePartsService,
		ThemeService,
		provideHttpClient(withInterceptorsFromDi()),
		provideRouter(rootRouterConfig, withHashLocation())
	]
}).catch((err: unknown) => {
	// eslint-disable-next-line no-console -- fallo de arranque; útil en diagnóstico
	console.error(err);
});
